(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  var header = document.querySelector('.site-header');
  window.addEventListener('scroll', function() {
    header.classList.toggle('has-scrolled', window.scrollY > 0);
  }, { passive: true });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.product-slider').forEach(function(slider) {
    var track = slider.querySelector('[data-slider-track]');
    if (!track) return;

    var prevBtns = slider.querySelectorAll('.product-slider__btn--prev');
    var nextBtns = slider.querySelectorAll('.product-slider__btn--next');

    function updateArrows() {
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      prevBtns.forEach(function(btn) { btn.style.opacity = atStart ? '0' : ''; btn.style.pointerEvents = atStart ? 'none' : ''; });
      nextBtns.forEach(function(btn) { btn.style.opacity = atEnd ? '0' : ''; btn.style.pointerEvents = atEnd ? 'none' : ''; });
    }

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows, { passive: true });
    updateArrows();

    slider.querySelectorAll('.product-slider__btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = track.querySelector('.product-slider__item');
        if (!item) return;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var itemsPerPage = window.innerWidth <= 768 ? 2 : window.innerWidth <= 1150 ? 3 : 4;
        var step = (item.offsetWidth + gap) * itemsPerPage;
        var dir = btn.dataset.dir === 'prev' ? -step : step;
        var maxScroll = track.scrollWidth - track.clientWidth;
        var target = Math.max(0, Math.min(track.scrollLeft + dir, maxScroll));
        track.scrollTo({ left: target, behavior: 'smooth' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    var variants = window.__productVariants || [];

    function getSelectedOptions() {
      var opts = {};
      document.querySelectorAll('.product__option-btns').forEach(function(group) {
        var pos = group.dataset.optionPosition;
        var sel = group.querySelector('.is-selected');
        if (sel) opts[pos] = sel.dataset.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function(v) {
        return Object.keys(opts).every(function(pos) {
          return v['option' + pos] === opts[pos];
        });
      });
    }

    function updateProduct(variant) {
      if (!variant) return;

      document.getElementById('variant-id').value = variant.id;

      var priceEl = document.getElementById('product-price');
      var compareEl = document.getElementById('product-compare');
      if (priceEl) priceEl.textContent = variant.price;
      if (compareEl) {
        if (variant.compareAtPrice) {
          compareEl.textContent = variant.compareAtPrice;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      var addBtn = document.getElementById('add-to-cart-btn');
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available
          ? addBtn.dataset.textAvailable
          : addBtn.dataset.textUnavailable;
      }
    }

    document.querySelectorAll('.product__option-btns').forEach(function(group) {
      group.querySelectorAll('.product__option-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          group.querySelectorAll('.product__option-btn').forEach(function(b) {
            b.classList.remove('is-selected');
          });
          btn.classList.add('is-selected');
          updateProduct(findVariant(getSelectedOptions()));
        });
      });
    });

    document.querySelectorAll('.product__qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        document.querySelectorAll('.product__qty-btn').forEach(function(b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        document.getElementById('quantity-input').value = btn.dataset.qty;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
